import React from 'react';

import ElementConstants from '../../../../shared/constants/elements';

import FormActions from '../../../../shared/actions/form';

import RadioButton from '../../form-elements/inputs/radio-button';
import Checkbox from '../../form-elements/inputs/checkbox';
import OtherMultiChoicePayOption from '../../form-elements/inputs/other-multi-choice-pay-option';
import Localization from '../../../../../../../common/edlio-js/models/BackendLocalization';

import SVGIcon from '../../../../../../../common/react/components/svg-icon';

export default class CustomGroupedInput extends React.Component {
	constructor(props) {
		super(props);
	}

	handleBlur = () => {
		// Using setTimeout(fn, 0) to ensure that this handleBlur occurs after the child input elements' handleBlur
		// Child input handleBlur -> format input value
		// this handleBlur -> saves new label to go to Mongo
		setTimeout(() => {
			const {
				fieldsetIndex,
				index,
				rowIndex,
				choiceNumber
			} = this.props;

			const oldValue = this.props.data.label;

			const inputValues = this.refs.customGroupedInput.refs;
			let newValue = [];
			for (let key in inputValues) {
				newValue.push(inputValues[key].refs.input.value);
			}

			if ( newValue !== '' && newValue !== oldValue ) {
				FormActions.updateCustomGroupedElementLabel(fieldsetIndex, rowIndex, index, choiceNumber, newValue);
			}
		}, 0);
	}

	remove = () => {
		this.props.removeCallback(this.props.choiceNumber);
	}

	render() {
		const { type, data, choiceNumber, parentId, showRemoveOption } = this.props;
		const localization = new Localization(window.edlio.localizations);

		let classes;
		let svgName;

		switch(type) {
			case ElementConstants.INPUT_GROUPS.RADIO_BUTTONS:
				classes = 'radio input';
				svgName = 'filled-circle';
				break;
			case ElementConstants.INPUT_GROUPS.CHECKBOXES:
				classes = 'checkbox input';
				svgName = 'filled-square';
				break;
			case ElementConstants.PAYMENTS.MULTI_CHOICE:
				classes = 'radio input';
				svgName = 'filled-circle';
				break;
		}

		let customInput;

		if (type === ElementConstants.PAYMENTS.MULTI_CHOICE) {
			customInput =
			<div className='custom grouped-input' onBlur={this.handleBlur}>
				<div className={classes}>
					<OtherMultiChoicePayOption ref='customGroupedInput' data={data} parentId={parentId}/>
				</div>
				{ showRemoveOption &&
					<div className='tools'>
						<a className='delete' href='javascript:;' onClick={this.remove}>
							<SVGIcon name='trash-o' />
						</a>
					</div>
				}
			</div>
			;
		} else {
			customInput =
			<div className='custom grouped-input' onBlur={this.handleBlur}>
				<div className={classes}>
					<SVGIcon name={svgName} />
					<label>{localization.localize('Other')}</label>
				</div>
				{ showRemoveOption &&
					<div className='tools'>
						<a className='delete' href='javascript:;' onClick={this.remove}>
							<SVGIcon name='trash-o' />
						</a>
					</div>
				}
			</div>
			;
		}

		return customInput;
	}
}



// WEBPACK FOOTER //
// ./src/main/webapps/features/form-builder/react/editor/components/form-elements/input-groups/custom-grouped-input.js